import axios from 'axios'
import LinkModel from '@/services/Models/LinkModel'

export default {
  postLinks(links) {
    return axios.post('/links', links)
            .then(mapToLinks)
  },

  deleteLink(id) {
    return axios.delete('/links/' + id)
  }
}

function mapToLinks(response) {
  return response.data.map(LinkModel)
}



// WEBPACK FOOTER //
// ./src/services/Api/LinkApi.js